import React from 'react';

import {PictureAndScroll, Video} from 'views/components';
import {translate} from 'views/module';

const Pulse = () => {
  const text = [
    {
      title: translate('pulse.Pulse.1.Title'),
      body: translate('pulse.Pulse.1.Body'),
    },
    {
      title: translate('pulse.Pulse.2.Title'),
      body: translate('pulse.Pulse.2.Body'),
    },
    {
      title: translate('pulse.Pulse.3.Title'),
      body: translate('pulse.Pulse.3.Body'),
    },
  ];

  const title = translate('pulse.Pulse.Title');
  const video = <Video src={'/videos/pulse/create.mov'} style={{maxHeight: '100vh', maxWidth: '700px'}}/>;

  return (
    <PictureAndScroll
      title={title}
      text={text}
      image={video}
      backgroundColor='rgba(255, 255, 255, 0.8)'
      sx={{
        backdropFilter: 'blur(5px)',
        borderRadius: '20px',
      }}
    />
  );
};

export default Pulse;
